import React, { useState } from 'react';
import OptionalFeaturesBulk, {
  SECTION_ANCHOR as OPTIONAL_FEATURES_ANCHOR,
} from './OptionalFeaturesBulk';
import AccountActions, { SECTION_ANCHOR as ACTIONS_ANCHOR } from './AccountActions';
import useDeepLinkedSection from '../navigation/useDeepLinkedSection';
import './Accounts.css';

// DJB-208: Accounts › Settings sub-page — the canonical shell for the
// fleet-wide settings sections. Same treatment as Accounts Manager (DJB-171):
// the Dashboard's borderless collapsible sections inside the 1800px
// .accounts-page container, every section expanded by default and collapsing
// independently.
//
// Each section owns its DashboardSection (anchor, title, info line) and takes
// the open state + toggle from this shell:
//   - Optional Features (DJB-209) — OptionalFeaturesBulk
//   - Actions (DJB-210) — AccountActions
export const SETTINGS_SECTION_DEFS = [
  { key: 'optional-features', anchor: OPTIONAL_FEATURES_ANCHOR, Section: OptionalFeaturesBulk },
  { key: 'actions', anchor: ACTIONS_ANCHOR, Section: AccountActions },
];

// anchor → section key, the shape useDeepLinkedSection consumes (DJB-112)
export const SETTINGS_SECTIONS = Object.fromEntries(
  SETTINGS_SECTION_DEFS.map(({ anchor, key }) => [anchor, key])
);

const AccountSettings = () => {
  const [openSections, setOpenSections] = useState(
    () => new Set(SETTINGS_SECTION_DEFS.map(({ key }) => key))
  );

  const openSection = (key) =>
    setOpenSections((prev) => (prev.has(key) ? prev : new Set(prev).add(key)));

  const toggleSection = (key) =>
    setOpenSections((prev) => {
      const next = new Set(prev);
      if (next.has(key)) {
        next.delete(key);
      } else {
        next.add(key);
      }
      return next;
    });

  // DJB-112: a section picked from the left nav arrives as ?section=<anchor>
  // and must open even if the user collapsed it
  useDeepLinkedSection(SETTINGS_SECTIONS, openSection);

  return (
    <div className="accounts-page accounts-settings-page">
      {SETTINGS_SECTION_DEFS.map(({ key, Section }) => (
        <Section
          key={key}
          active={openSections.has(key)}
          onToggle={() => toggleSection(key)}
        />
      ))}
    </div>
  );
};

export default AccountSettings;
